import { create } from "zustand";

export type TypeActivate =
  | "krafton"
  | "masterPlan"
  | "Space mode"
  | "Timeline mode"
  | "panorama"
  | "master"
  | "c4site"
  | "";

export type TCommonData = {
  isActive: TypeActivate;
  folder: boolean;
  slider: boolean;
  openIndex: string | null;
};

const useCommonDataStore = create<{
  commonData: TCommonData;
  setCommonData: (data: Partial<TCommonData>) => void; // 일부분만 업데이트
}>((set) => ({
  commonData: {
    isActive: "",
    folder:false,
    slider:false,
    openIndex: null,
  },
  setCommonData: (data) => set((prev) => ({
    commonData: {
      ...prev.commonData, // 이전 상태를 복사
      ...data, // 새로운 데이터로 업데이트
    },
  })),
}));

export default useCommonDataStore;
